import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

const Banner = ({ onBookDemo }) => {
  return (
    <section className="banner" aria-labelledby="banner-heading">
      <Container>
        <Row className="justify-content-center text-center">
          <Col xs={12} lg={10} xl={9}>
            <p className="banner__eyebrow">
              The operating system for medical lien negotiations
            </p>

            <h1 id="banner-heading" className="banner__title">
              Recover settled funds faster.
              {/* <br className="d-none d-md-block" /> */}
              {' '}Stop chasing providers by hand.
            </h1>

            <p className="banner__description mx-auto">
              Lien Logic replaces spreadsheets and inbox threads with one system
              for lien reduction negotiation, provider communication, and
              disbursement — built for personal injury firms.
            </p>

            <div className="banner__actions d-flex flex-column flex-sm-row align-items-center justify-content-center gap-2 gap-sm-3">
              <Button
                type="button"
                className="banner__btn banner__btn--primary"
                onClick={onBookDemo}
              >
                Book a Demo
              </Button>
              <Button
                href="#how-it-works"
                variant="outline-secondary"
                className="banner__btn banner__btn--secondary"
              >
                See How It Works
              </Button>
            </div>
          </Col>
        </Row>

        <Row className="justify-content-center">
          <Col xs={12} lg={11} xl={10}>
            <div className="banner__visual">
              <video
                className="banner__video img-fluid"
                src="https://d1xenkt2s8nha8.cloudfront.net/videos/lien-logic-v4.mp4"
                autoPlay
                muted
                loop
                playsInline
                controls
                aria-label="Lien Logic dashboard showing open cases, pending responses, undisbursed funds, and recovery overview"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Banner;
